import Elt from "./Elt";

import "./Progress.css";

interface ProgressProps {
  data: Record<string, boolean>,
}

function Progress({data} : ProgressProps) : JSX.Element {
  const elts = Object.entries(data).map(([letter, done]) => (
    <Elt className={done ? "done" : ""} key={letter}>{letter}</Elt>
  ));

  return <div className="Progress">{elts}</div>;
}

export default Progress;